import React from "react";
//ESTILOS
import "./AppCarrusel.css";
//MEDIAS
//PRIMEREACT

function AppCarrusel() {



  return (
    <>
      <div className="grid-nogutter">
        <div className="col-10 col-offset-1 ingreso">
          <p>Muchas gracias por participar</p>
        </div>
      </div>
    </>
  );
}

export default AppCarrusel;
